import PropTypes from 'prop-types';

/**
utils for accepting z-index prop
*/
const validProps = ['minor', 'mid', 'mad', 'major', 'top'];
const zIndexProps = PropTypes.oneOf(validProps);

// Given a z-index alias, returns the CSS class or null
function getZIndex(z) {
  if (validProps.includes(z)) return `st_z-${z}`;
  return null;
}

export { getZIndex as g, zIndexProps as z };
